export const SourceTypes = {
  Database: 1,
  Web_API: 2,
};
